<template>
  <div class="header row align-center">
    <div class="row grid-12 justify-center align-center">
      <img src="../assets/img/logo.png" class="logo" alt="Logo NetSupport" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderPage",

  data() {
    return {};
  }
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;
.header {
 
  height: 70px;
  @media (max-width: $small) {
    height: 82px;
  }
  background: $gray-1;

  .logo {
    width: 163px;
    height: 33px;
    margin-left: 35px;

    &-icon {
      width: 45px;
      margin: auto;
    }
  }
}
</style>
